import axios from '@/axios/axios2'

// 获取团队业绩日维度
export const getDataTeamDay = params =>
  axios.post('/statistics/getDataTeamDay', params)

// 获取团队业绩月维度
export const getDataTeamMonth = params =>
  axios.post('/statistics/getDataTeamMonth', params)
